import { render, staticRenderFns } from "./rankingList.vue?vue&type=template&id=412496cd&scoped=true&"
import script from "./rankingList.vue?vue&type=script&lang=ts&"
export * from "./rankingList.vue?vue&type=script&lang=ts&"
import style0 from "./rankingList.vue?vue&type=style&index=0&id=412496cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412496cd",
  null
  
)

export default component.exports